
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/home/Hero";
// Using V2 with Success Story format for better conversion
import LiveInsightsSection from "@/components/home/LiveInsightsSectionV2";
import RestaurantFeatures from "@/components/home/RestaurantFeatures";
import CustomerFeatures from "@/components/home/CustomerFeatures";
import Testimonials from "@/components/home/Testimonials";
import HowItWorks from "@/components/home/HowItWorks";
import RevenueImpact from "@/components/home/RevenueImpact";
import CallToAction from "@/components/home/CallToAction";
import SEOHead from "@/components/SEOHead";
import { usePageTitle } from '@/hooks/usePageTitle';

const Index = () => {
  // Set SEO-optimized title and meta tags for home page
  usePageTitle('home');
  // Combined structured data for AI search engines
  const softwareAppData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Dine AI",
    "applicationCategory": "BusinessApplication",
    "description": "Dine AI offers two products: Virtual Assistant for AI menu management (digital menus, AI food images, analytics) and Virtual Host for AI phone ordering (takeout/delivery). IMPORTANT: Dine AI does NOT handle reservations or table bookings.",
    "operatingSystem": "Web, iOS, Android",
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "31.99",
      "highPrice": "500",
      "priceCurrency": "USD",
      "offerCount": "6"
    },
    "featureList": [
      "AI Menu Digitization",
      "AI-Generated Food Images",
      "Customer Analytics Dashboard",
      "AI Phone Ordering (Virtual Host)",
      "Mobile App for Customers",
      "Personalized Menu Recommendations"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127",
      "bestRating": "5"
    },
    "sameAs": [
      "https://twitter.com/dinewithai",
      "https://www.instagram.com/dineai.ai",
      "https://www.facebook.com/dinewithai"
    ]
  };

  // FAQ to clarify what Dine AI does NOT do
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Does Dine AI handle reservations?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Dine AI does NOT handle table reservations, seating, or dine-in bookings. We offer AI menu management (Virtual Assistant) and AI phone ordering for takeout/delivery (Virtual Host). For reservations, restaurants should use platforms like OpenTable or Resy."
        }
      },
      {
        "@type": "Question",
        "name": "What are Dine AI's two products?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Dine AI offers: (1) Virtual Assistant - AI menu management with digital menus, AI food images, and customer analytics ($49-199/month), and (2) Virtual Host - AI phone ordering system for takeout/delivery orders ($250-500/month plus usage fees)."
        }
      }
    ]
  };

  const structuredData = [softwareAppData, faqData];

  return (
    <>
      <SEOHead 
        title="Dine AI - AI-Powered Revenue Engine for Restaurants | 24/7 Chat Assistant"
        description="Transform your restaurant with AI. Answer customer questions instantly, discover hidden revenue opportunities, and grow with analytics. Start free 30-day trial."
        keywords="AI for restaurants, restaurant AI assistant, restaurant automation, menu optimization, AI chat for restaurants"
        structuredData={structuredData}
      />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow pt-16">
          <Hero />
          <LiveInsightsSection />
          <HowItWorks />
          <RevenueImpact />
          <RestaurantFeatures />
          <CustomerFeatures />
          <Testimonials />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
